<!-- NOTE: This page is used in Nile & AC -->

<ng-container *ngIf="data.success; else noData">
	<!-- Big header -->
	<dl-section-header
		data-cy="esg-metrics-section-header"
		[titleDcr]="titleDcrKey"
		[subTitleDcr]="subTitleDcrKey"
		[tooltipDcr]="tooltipDcr"
		[showSectionSeparator]="showSectionSeparator"
		[poweredByDcr]="''"
		[asOfDate]="asOfDate"
	></dl-section-header>

	<ac-cta-link
		*ngIf="showMethodologyCta && methodologyLink"
		class="margin-bottom-20 text-16-bold"
		[link]="methodologyLink"
		icon="arrow-right"
		[track-event]="applicationName + ':esg:methodology-cta'"
	>
		<span dcrHTMLKey="ESG_METHODOLOGY_CTA_LABEL">Learn about MSCI ESG Scores</span>
	</ac-cta-link>

	<!-- Charts -->
	<ng-container *ngIf="chartTabs?.length">
		<div class="padding-top-8 title-icon" *ngIf="tabsTitleDcrKey">
			<span class="text-18-bold" [dcrHTMLKey]="tabsTitleDcrKey" data-cy="esg-score-chart-title">
				<span>{{ tabsTitleDcrKey }}</span>
			</span>
			<icon type="info-circle" class="info-circle" [tooltip-dcr]="tabsTitleDcrKey + '_TOOLTIP'" [analytic-data]="{ linkName: tabsTitleDcrKey + '_TOOLTIP' }"></icon>
		</div>
		<bfa-tabs type="underline" [hideTabBarIfOneTab]="hideTabBarIfOneTab" custom-classes="esg-container">
			<ng-container *ngFor="let tab of chartTabs; index as tabIndex">
				<ng-container *ngIf="!tab.error">
					<ng-template #tabItem>
						<p
							*dcrIfExists="tab?.config?.title?.label?.key + '_SUBTITLE'"
							[dcrHTMLKey]="tab?.config?.title?.label?.key + '_SUBTITLE'"
							class="padding-bottom-20 text-16 {{ chartTabs.length === 1 && hideTabBarIfOneTab ? 'padding-top-8' : '' }}"
						></p>
						<bfa-chart
							[attr.data-cy]="'esg ' + tab?.config?.title?.label + ' chart' | slugify"
							[data]="tab"
							[type]="chartType"
							[name]="chartName"
							[customAttributes]="customChartAttributes[tabIndex]"
						></bfa-chart>
					</ng-template>
					<tab-panel [tab-title]="tab?.config?.title?.label" [templateRef]="tabItem"></tab-panel>
				</ng-container>
			</ng-container>
		</bfa-tabs>

		<section class="padding-top-20">
			<ac-disclosure [isExpandable]="false" [dcrKey]="chartDisclosureDcrKey"></ac-disclosure>
			<ac-disclosure [isExpandable]="false" *ngIf="showDisclosureAsOfDate && asOfDate">
				<span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ asOfDate: asOfDate }">As of asOfDate</span>
			</ac-disclosure>
		</section>
	</ng-container>

	<!-- Top 5 / bottom 5 holdings table -->
	<ng-container *ngIf="isTopBottomHoldingsTableEnabled && showTopBottomHoldingsTable">
		<div class="row padding-top-20">
			<div class="col-24">
				<esg-holding-rankings-portfolio-data
					[data]="data"
					[tabs]="topHoldingTabs"
					[shouldShowNoDataComponent]="false"
					disclosureKey="ESG_FUND_DISCLOSURE"
					[singlePortColumnProportions]="singlePortColumnProportions"
					[multiPortColumnProportions]="multiPortColumnProportions"
					[asOfDate]="asOfDate"
				>
				</esg-holding-rankings-portfolio-data>
			</div>
		</div>
		<div class="row padding-top-20">
			<div class="col-24">
				<esg-holding-rankings-portfolio-data
					[data]="data"
					[tabs]="bottomHoldingTabs"
					[shouldShowNoDataComponent]="false"
					disclosureKey="ESG_FUND_DISCLOSURE"
					[singlePortColumnProportions]="singlePortColumnProportions"
					[multiPortColumnProportions]="multiPortColumnProportions"
					[asOfDate]="asOfDate"
				>
				</esg-holding-rankings-portfolio-data>
			</div>
		</div>
	</ng-container>

	<!-- Portfolio Coverage -->
	<ng-container *ngIf="percentagesTab">
		<div class="row padding-top-20">
			<div [ngClass]="{ 'col-16': !wideTables || shouldDisplayRatingsScale, 'col-24': wideTables && !shouldDisplayRatingsScale }">
				<div class="title-icon padding-bottom-20">
					<span class="text-18-bold text-uppercase" data-cy="esg-coverage-title" [dcrHTMLKey]="percentagesTab?.config?.title?.label?.key">
						<span>{{ percentagesTab?.config?.title?.label?.translated }}</span>
					</span>
					<icon
						type="info-circle"
						class="info-circle"
						[tooltip-dcr]="percentagesTab?.config?.title?.label?.key + '_TOOLTIP'"
						[analytic-data]="{ linkName: percentagesTab?.config?.title?.label?.key + '_TOOLTIP' }"
					></icon>
				</div>
				<dl-display-table *ngIf="showPortfolioCoverageAsTable" [data]="percentagesTab" [bordered]="true" [padded]="true"></dl-display-table>
				<esg-coverage *ngIf="!showPortfolioCoverageAsTable" [data]="percentagesTab" [coverageDcrKey]="coverageDcrKey"></esg-coverage>
			</div>
		</div>
		<section class="padding-top-20">
			<ac-disclosure [isExpandable]="false" [dcrKey]="disclosureDcrKey"></ac-disclosure>
			<ac-disclosure [isExpandable]="false" *ngIf="showDisclosureAsOfDate && asOfDate">
				<span dcrHTMLKey="AS_OF_DATE_DYNAMIC" [dcrSubstitutions]="{ asOfDate: asOfDate }">As of asOfDate</span>
			</ac-disclosure>
		</section>
	</ng-container>

	<ng-container *ngIf="showCarbonScoreImpact">
		<!-- Carbon Emissions -->
		<esg-carbon-emissions-impact *ngIf="carbonScoreTab" [data]="carbonScoreTab" [asOfDate]="asOfDate"> </esg-carbon-emissions-impact>
	</ng-container>
</ng-container>

<ng-template #noData>
	<dl-no-data *ngIf="shouldShowNoDataComponent" [data]="data"></dl-no-data>
</ng-template>
